module.exports = __webpack_public_path__ + "img/partner27.16fdae39.png";